module.exports = __webpack_public_path__ + "img/phone.21fa952b.webp";